import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { ResourceUtils } from "./resourceUtils";
import { LoginClientManager } from '../ClientManagers/LoginClientManager';
import { LibraryThing } from "../widget/LibraryThingWidget";
import { AvailabilityFactory } from '../../availability/AvailabilityFactory';
import { AccountHolder } from "@tlc/ls2pac/components/Account";


export const LS2PAC_Utils = (function ( $ ) {

	var requestButtonExt;
	var amazonLogoExt;
	var detailsPageAmazonLogoExt;
	var callAndCollectionForResultsExt;

	return {
		getCallAndCollectionBasedOnAvailability: function ( resource, useFindOnShelfLabel ) {
			var collectionAndCall = "";

			if( resource.holdingForOnShelf != null ) {
				if( useFindOnShelfLabel == true ) {
					collectionAndCall += "<strong>" + ApplicationData.language.findOnShelf + "</strong>";
				}
				collectionAndCall += ResourceUtils.getCallAndCollection( resource );
			}

			return collectionAndCall;
		},
		isResourceAvailableLocally:              function ( resource ) {
			var _currentBranch = ApplicationData.getBranchToUseForAvailability(),
				local = false;

			resource.availableLocally = false;
			$.each( resource.holdingsInformations, function ( index, holding ) {
				if( holding.available == true ) {
					if( _currentBranch == parseInt(holding.branchIdentifier, 10) ) {
						resource.availableLocally = true;
						local = true;
						return false;
					}
				}
			} );
			return local;
		},
		isEveryItemAvailableLocally:              function ( resource ) {
			var _currentBranch = ApplicationData.getBranchToUseForAvailability(),
				local = true;

			resource.availableLocally = true;
			$.each( resource.holdingsInformations, function ( index, holding ) {
				if( !holding.available || (holding.available && _currentBranch != parseInt(holding.branchIdentifier, 10))) {
					resource.availableLocally = false;
					local = false;
					return false;
				}
			} );
			return local;
		},
		sortByCollectionName:                    function ( a, b ) {
			var x = (a.collectionName) ? a.collectionName.toLowerCase() : "";
			var y = (b.collectionName) ? b.collectionName.toLowerCase() : "";
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		},
		sortByCallNumber:                        function ( a, b ) {
			//orig:  /^([A-Z]+)\s?(\d+(?:\.\d+)?)\s?([A-Z]*)(\d*)\.?([A-Z]*)(\d*)( (?:\d{4})?)?(.*)?/
			var reg = /^\s*([A-Z]+)\s*(\d+(?:\s*\.\s*\d+)?)?\s*(?:\.?\s*([A-Z]+)\s*(\d+)?)?(?:\.?\s*([A-Z]+)\s*(\d+)?)?\s*(.*?)\s*$/;

			var x = a.callNumber.toLowerCase();
			var y = b.callNumber.toLowerCase();

			var $regsA = reg.exec( x );
			var $regsB = reg.exec( y );

			if( ($regsA === null) && ($regsB === null) ) {
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			} else {
				TLCLogger.log( "something matched!!" );
				TLCLogger.log( $regsA );
				TLCLogger.log( $regsB );
				//if first part greater then return that
				//if first part equal, check second part, return that
				if( $regsA[1] != $regsB[1] ) {
					return ($regsA[1] > $regsB[1]);
				} else {
					if( $regsA[2] != $regsB[2] ) {
						return ($regsA[2] > $regsB[2]);
					} else {
						if( $regsA[3] != $regsB[3] ) {
							return ($regsA[3] > $regsB[3]);
						} else {
							if( $regsA[4] != $regsB[4] ) {
								return (("0." + $regsA[4]) > ("0." + $regsB[4]));
							} else {
								if( $regsA[5] != $regsB[5] ) {
									return ($regsA[5] > $regsB[5]);
								} else {
									if( $regsA[6] != $regsB[6] ) {
										return ($regsA[6] > $regsB[6]);
									} else {
										if( $regsA[7] != $regsB[7] ) {
											return ($regsA[7] > $regsB[7]);
										} else {
											return ($regsA[8] > $regsB[8]);
										}
									}
								}
							}
						}
					}
				}
			}
		},
		getFakePagingDataToSendToFullDetails:    function ( resources, index ) {
			//full details expects paged data.  If you need to send a list of resources to full details that doesn't have 'pages' then you can use this to fake it
			index = index || 0;
			var data = {
				index:        index,
				resourceData: {totalPages: 1, currentPage: 1, resources: resources}
			};
			// TODO note QA impact
			// data.resourceData = $.extend( data.resourceData, LS2PacSearchDatabaseManager.getCurrentDatabaseConfig() );
			return data;
		},
		isBookJacketAvailable:                   function ( resource, jacketType ) {
			const {enums} = LibraryThing;
			if( resource.missingContent === null ) {
				return true;
			}
			switch( jacketType ) {
				case enums.requestType.bookJacketSmall:
					return !resource.missingContent.missingSmallJacket;
				case enums.requestType.bookJacketMedium:
					return !resource.missingContent.missingMediumJacket;
				case enums.requestType.bookJacketLarge:
					return !resource.missingContent.missingLargeJacket;
			}
		},
		// getRequestButtonExt:                     function () { //TODO remove
		// 	if( !requestButtonExt ) {
		// 		requestButtonExt = TLCEXT.Template( '<li {resourceUtil.hideIfAdmin}><a {resourceUtil.getRequestButtonLink} class="{resourceUtil.getRequestButtonActionClass} {resourceUtil.getIsRequestDisabled} btn primary" {resourceUtil.getEResourceAttributes} data-index="{index}">{resourceUtil.getRequestButtonText}</a></li>' );
		// 	}
		// 	return requestButtonExt;
		// },
		getAvailabilityLink:                     function ( data ) {
			if( data.downloadable && data.link ) {
				return 'href="' + data.link + '"';
			}
			return "";
		},
		getAmazonLogoExt:                        function () {
			if( !amazonLogoExt ) {
				amazonLogoExt = TLCEXT.Template( "<dt class=\"imageByAmazon\">{languageUtil.imageBy}:</dt><dd><a href=\"{amazonUrl}\" title=\"{amazonUrl}\" target=\"_blank\"><img src=\"images/AmazonLogo75px.png\" alt=\"{languageUtil.amazonLogoAltText}\" /></a></dd>" );
			}
			return amazonLogoExt;
		},
		getDetailsPageAmazonLogoExt:             function () {
			if( !detailsPageAmazonLogoExt ) {
				detailsPageAmazonLogoExt = TLCEXT.Template( "<h5>{languageUtil.imageBy}:</h5><p><a href=\"{amazonUrl}\" title=\"{amazonUrl}\" target=\"_blank\"><img src=\"images/AmazonLogo75px.png\" alt=\"{languageUtil.amazonLogoAltText}\" /></a></p>" );
			}
			return detailsPageAmazonLogoExt;
		},
		getDetailsPageAmazonLogoExtKids:         function () {
			if( !detailsPageAmazonLogoExt ) {
				detailsPageAmazonLogoExt = TLCEXT.Template(
					"<div class='amazon-logo'>" +
					'<a class="external-link" href="{amazonUrl}" target="_blank">' +
					'<img src="images/AmazonLogo75px.png" alt="{languageUtil.amazonLogoAltText}" />' +
					'</a>' +
					'</div>'
				);
			}
			return detailsPageAmazonLogoExt;
		},
		getQualifiedSearchTerm:                  function ( term, type ) {
			if( type === 'title' ||
				type === 'author' ||
				type === 'subject' ||
				type === 'seriestitle' ||
				type === 'authorsuggestion' ||
				type === 'tag' ||
				type === 'isbn' ||
				type === 'CallNumber'
			) {
				term = ApplicationData.getSearchTypeHash( type ).type + ':"' + term + '"';
			}
			if(typeof term === "object"){
				return JSON.stringify(term);
			}

			return term;
		},
		isSearchTermAnObject:                    function ( term ) {
			try {

				if(term === null){
					return false;
				}

				if (typeof term === "object" ) {
					return true;
				}

				var result = JSON.parse( term );
				if(typeof result === "object" ) {
					return true;
				}

				return false;
			}  catch (e) {
				return false;
			}

		},
		getLegitAvailableCopiesLength:           function ( holdingsInformations ) {
			return $.grep( holdingsInformations,
				function ( holding, index ) {
					return ((holding.available) && (holding.nonCirculating == false));
				} ).length;
		},
		getAvailabilityDisplayObject:            function ( resource ) {
			return AvailabilityFactory.displayAvailability( "", resource );
		},
		getHoldingsForLimitedBranches:           function ( passedHoldingsInfo ) {
			var holdingsInfo = passedHoldingsInfo;
			if( ApplicationData.branchLimitsUtil.getIsLimiting() ) {
				var branchLimits = ApplicationData.branchLimitsUtil.getLimitedBranches();
				holdingsInfo = $.grep( holdingsInfo, function ( holding ) {
					return ($.inArray( holding.branchIdentifier, branchLimits ) != -1);
				} );
			}
			holdingsInfo = $.grep( holdingsInfo, function ( holding ) {
				return (holding.hideFromPublic === false);
			} );
			return holdingsInfo;
		},
		getResourcesForLimitedBranches:          function ( resources ) {
			var newResources = resources;
			if( ApplicationData.branchLimitsUtil.getIsLimiting() ) {
				var branchLimits = ApplicationData.branchLimitsUtil.getLimitedBranches();
				$.each( resources, function ( index, resource ) {
					var holdingsInfo = LS2PAC_Utils.getHoldingsForLimitedBranches( resource.holdingsInformations );
					if( holdingsInfo.length === 0 ) {
						resource.isHidden = true;
					} else {
						resource.isHidden = false;
					}
				} );
				newResources = $.grep( resources, function ( resource ) {
					return (resource.isHidden !== true);
				} );
			}
			return newResources;
		},
		isValidPatronIdUser:                     function ( user ) {
			return (user.patronId !== undefined && user.patronId !== null && user.patronId > "");
		},
		showBulkRequestOption:                   function () {
			if( AccountHolder.isAdmin ) {
				return false;
			}
			var supportsAvailability = ApplicationData.supportedFunctionality.supportsAvailabilityFunctionality,
				allowHolds = ApplicationData.locationConfiguration.getAllowHolds();

			if( !supportsAvailability || allowHolds.title === false ) {
				return false;
			}
			else {
				return true;
			}
		},
		setDisableRequestButton: function(resource, allowHolds, showBookings) { // Resource Object only (no Array)
			resource.holdingsInformations = resource.holdingsInformations || [];

			if (resource.serial) {
				LS2PAC_Utils.isEveryItemAvailableLocally(resource);
			} else {
				LS2PAC_Utils.isResourceAvailableLocally(resource);
			}

			if (((resource.availableLocally && !allowHolds.onShelf) && !showBookings) || resource.holdingsInformations.length == 0) { // could be eResource?
				resource.disableRequestButton = true;
			}
		},
		showRequestButton:                       function ( resource ) { // Resource Object or Array of Resource Objects

			if( AccountHolder.isAdmin ) {
				return false;
			}
			var supportsAvailability = ApplicationData.supportedFunctionality.supportsAvailabilityFunctionality,
				showBookings = ApplicationData.locationConfiguration.getAllowBookings(),
				allowHolds = ApplicationData.locationConfiguration.getAllowHolds();

			if( !supportsAvailability ) {
				return false;
			}

			if( (allowHolds.item || allowHolds.title || showBookings) && resource ) {

				if(Array.isArray(resource)) {

					if( resource.length === 0 ) { //empty Array
						return false;
					}

					if( resource.length > 1 ) { // batch
						return true;
					}

					if (resource[0].serial && !allowHolds.item) { // must use item level holds for a serial item
						return false;
					}

					LS2PAC_Utils.setDisableRequestButton( resource[0], allowHolds, showBookings );

				}
				else {
					if (resource.serial && !allowHolds.item) { // must use item level holds for a serial item
						return false;
					}

					LS2PAC_Utils.setDisableRequestButton( resource, allowHolds, showBookings );

				}

				return true;
			}
			else {
				return false;
			}
		},
		showDownloadButton:                      function () {
			if( AccountHolder.isAdmin ) {
				return;
			}
			return true;
		},
		// GetCacheBusterForUrl:                    function ( theUrl ) {
		// 	if( theUrl.indexOf( "?" ) === -1 ) {
		// 		theUrl += "?";
		// 	} else {
		// 		theUrl += "&";
		// 	}
		// 	theUrl += "cacheBuster=" + tlc.buildNumber;
		// 	return theUrl;
		// },
		getVolumeAndCopyText:                    function ( holding ) {
			return ((holding.year !== null) ? holding.year + " " : "") + ((holding.volume !== null) ? holding.volume + " " : "") + ((holding.copy !== null) ? holding.copy + " " : "");
		},
		convertPenniesToCurrency:                function ( inString ) {
			if( inString === null || inString === undefined ) {
				return "0.00";
			}
			inString = inString + "";

			var newVal = 0;
			//if there is a negative symbol remove and save
			var negativeSign = inString.indexOf( "-" );
			inString = Math.abs( inString );
			if( inString === 0 ) {
				return newVal;
			} else if( inString < 10 ) {
				newVal = "0.0" + inString;
			} else if( inString >= 10 && inString < 100 ) {
				newVal = "0." + inString;
			} else if( inString >= 100 ) {
				var str = inString + "";
				var dec = str.substring( str.length - 2 );
				var num = str.substring( 0, str.length - 2 );
				newVal = num + "." + dec;
			}
			if( negativeSign != -1 ) {
				newVal = "-" + newVal;
			}
			return newVal;
		},
		convertBookingsData:                     function ( data ) {
			$.each( data, function ( index, booking ) {
				booking.whenBookedForString = new Date( booking.whenBookedFor ).format( ApplicationData.language.dateFormat );
				booking.whenDueBackString = new Date( booking.whenDueBack ).format( ApplicationData.language.dateFormat );
				var items = [];
				$.each( booking.components, function ( ind2, component ) {
					$.each( component.items, function ( ind3, item ) {
						items.push( item.title );
					} );
				} );
				booking.itemsString = items.join( ", " );
			} );
		},
		// adjustSummaryContent:                    function ( resource, element, animationCallback ) {
		// 	if( resource.content != null && resource.content != "" ) {
		// 		if( parseInt( resource.rtype, 10 ) == 1 ) {
		// 			element.removeAttr( "style" );
		// 			element.ellipsis( '<a href="javascript:;" class="moreSummary">...' + ApplicationData.language.showMoreSummary + '</a>' );
		// 			element.show();
		// 		} else {
		// 			element.css( "height", "auto" );
		// 		}
		// 	}
		// },
		getDomainFromURL:                        function ( url ) {
			var m = url.match( /^http:\/\/[^/]+/ );
			return m ? m[0] : null;
		},
		getURLVar:                               function ( variable, urlString ) {
			var vars = urlString.split( "&" );
			for( var i = 0; i < vars.length; i++ ) {
				var pair = vars[i].split( "=" );
				if( pair[0].toLowerCase() === variable.toLowerCase() ) {
					return decodeURIComponent( pair[1] );
				}
			}
			return null;
		},
		renewLoanLogic:                          function ( loansToRenew ) {
			var loanInfos = [];
			/*
			 Because LS doesn't support *unique ids* we have to make up our own on the backend so we can display
			 bookjackets and ratings with the .id property.  The call to renew does not take the id property so we have to store a separate list
			 of ids and send them along to the client manager so we can return them back and update the UI afterwords.
			 */
			var hackListOfIdsForHTML = [];
			$.each( loansToRenew, function ( index, loan ) {
				if (loan.downloadable){
					loanInfos.push( {
						downloadable: true,
						itemId:       loan.eresourceId,
						service:      loan.eresourceService
					} );
				} else {
					loanInfos.push( {
						downloadable: false,
						itemId:       loan.itemId
					} );
				}

				hackListOfIdsForHTML.push( {id: loan.id} );
			} );

			TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onRenewLoans, {
				loans:                loanInfos,
				hackListOfIdsForHTML: hackListOfIdsForHTML
			} );
		},
		handleLoanRenewSuccess:                  function ( successfulItems ) {
			$.each( successfulItems, function ( index, loanItem ) {
				var dueDate = $( "#" + loanItem.id + "_dueDate" );
				dueDate.removeClass( "overdue" );
				dueDate.html( ApplicationData.language.due + ": " + loanItem.dateString + " - " + ResourceUtils.getDaysRemainingForLoans( loanItem ) );

				var renewalCountObj = $( "#" + loanItem.id + "_renewalCount");
				var renewalsLeftObj = $( "#" + loanItem.id + "_renewalsLeft");
				renewalCountObj.text(parseInt(renewalCountObj.text()) + 1);
				if (renewalsLeftObj.length) {
					var renewalsLeft = parseInt(renewalsLeftObj.text()) - 1;
					renewalsLeftObj.text(renewalsLeft);
					if (renewalsLeft <= 0) {
						$( "#" + loanItem.id + "_renewLoanButton").hide();
					}
				}
			} );
		},
		cancelHoldLogic:                         function ( holds ) {
			var cancelHoldsInfos = [];
			$.each( holds, function ( index, hold ) {
				var holdInfo = {
					desireNumber:    hold.holdNumber,
					success:         false,
					holdQueueLength: hold.holdQueueLength,
					bibliographicId: hold.bibliographicId,
					whichBranch:     hold.holdPickupBranchId,
					status:          hold.status,
					downloadable:    (hold.resource != null) ? hold.resource.downloadable : false
				};
				cancelHoldsInfos.push( holdInfo );
			} );
			TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onCancelHolds, {holds: cancelHoldsInfos} );
		},
		getSuspendHoldInfos:                     function ( holds, suspendDate ) {
			var holdsInfos = [];
			suspendDate = (suspendDate) ? new Date( suspendDate ) : null;
			$.each( holds, function ( index, hold ) {
				var holdInfo = {
					desireNumber:    hold.holdNumber,
					success:         false,
					suspendDate:     suspendDate,
					queuePosition:   hold.holdQueueLength,
					bibliographicId: hold.bibliographicId,
					pickupBranchId:  hold.holdPickupBranchId,
					downloadable:    (hold.resource != null) ? hold.resource.downloadable : false
				};
				holdsInfos.push( holdInfo );
			} );
			return holdsInfos;
		},
		isEmptyString:                           function ( input ) {
			return input.trim().length === 0;
		},
		getDateString:                           function ( date ) {
			if( typeof(date) == "string" ) {
				date = date.replace( /-/g, "/" );
			}
			return new Date( date ).format( ApplicationData.language.dateFormat );
		},
		getDateAndTimeString:                    function ( date ) {
			if( typeof(date) == "string" ) {
				date = date.replace( /-/g, "/" );
			}
			var formattedDate = new Date( date ).format( ApplicationData.language.dateFormat );
			var time = new Date( date ).format( ApplicationData.language.timeFormat );
			return formattedDate + " " + time;
		},
		convertForUrl:                           function ( str ) {
			var replaced = str.replace( /[^A-Za-z0-9]/g, "-" );
			var old = null;

			while( old != replaced ) {
				old = replaced;
				replaced = replaced.replace( /--/g, "-" );
			}

			return replaced.toLowerCase();
		},
		downloadFile:                            function ( url ) {
			var hiddenIFrameID = LS2PAC_CONSTANTS.Ids.hiddenIFrameDownloader,
				iframe = document.getElementById( hiddenIFrameID );

			if( iframe === null ) {
				iframe = document.createElement( 'iframe' );
				iframe.id = hiddenIFrameID;
				iframe.style.display = 'none';
				document.body.appendChild( iframe );
			}

			iframe.src = url;
		}
	};

})( jQuery );

var dateFormat = function () {
	var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function ( val, len ) {
			val = String( val );
			len = len || 2;
			while( val.length < len ) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function ( date, mask, utc ) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if( arguments.length == 1 && Object.prototype.toString.call( date ) == "[object String]" && !/\d/.test( date ) ) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date( date ) : new Date;
		if( isNaN( date ) ) throw SyntaxError( "invalid date" );

		mask = String( dF.masks[mask] || mask || dF.masks["default"] );

		// Allow setting the utc argument via the mask
		if( mask.slice( 0, 4 ) == "UTC:" ) {
			mask = mask.slice( 4 );
			utc = true;
		}

		var _ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad( d ),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad( m + 1 ),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String( y ).slice( 2 ),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad( H % 12 || 12 ),
				H:    H,
				HH:   pad( H ),
				M:    M,
				MM:   pad( M ),
				s:    s,
				ss:   pad( s ),
				l:    pad( L, 3 ),
				L:    pad( L > 99 ? Math.round( L / 10 ) : L ),
				t:    H < 12 ? "a" : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A" : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String( date ).match( timezone ) || [""]).pop().replace( timezoneClip, "" ),
				o:    (o > 0 ? "-" : "+") + pad( Math.floor( Math.abs( o ) / 60 ) * 100 + Math.abs( o ) % 60, 4 ),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace( token, function ( $0 ) {
			return $0 in flags ? flags[$0] : $0.slice( 1, $0.length - 1 );
		} );
	};
}();

// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames:   [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November",
		"December"
	]
};

// For convenience...
Date.prototype.format = function ( mask, utc ) {
	return dateFormat( this, mask, utc );
};

Date.prototype.SubtractMonth = function ( numberOfMonths ) {
	var d = this;
	d.setMonth( d.getMonth() - numberOfMonths );
	if( d.getDate() > 27 ) {
		d.setDate( 27 );
	}
	return d;
};

Date.prototype.AddMonth = function ( numberOfMonths ) {
	var d = this;
	d.setMonth( d.getMonth() + numberOfMonths );
	if( d.getDate() > 27 ) {
		d.setDate( 27 );
	}
	return d;
};
